import { useLocation } from 'react-router-dom';

interface NavigationProps {
  onDonateClick: () => void;
}

export const Navigation = ({ onDonateClick }: NavigationProps) => {
  const { pathname } = useLocation();

  const linkClass = (href: string) => {
    const active = href === '/' ? pathname === '/' : pathname.startsWith(href);
    return `transition-colors border-b-2 pb-0.5 ${active ? 'text-foreground border-foreground' : 'border-transparent hover:text-foreground'}`;
  };

  return (
    <nav className="px-6 py-6 bg-white border-b border-border/30">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="font-normal text-foreground tracking-wide hover:text-foreground/80 transition-colors cursor-pointer" style={{ fontSize: '20px' }}>
          Fix the Formula
        </a>

        {/* Navigation Links */}
        <div className="flex items-center space-x-8 text-sm text-muted-foreground">
          <a href="/" className={linkClass('/')}>
            Data
          </a>
          <a href="/takeaways" className={linkClass('/takeaways')}>
            Takeaways
          </a>
          <a href="/about" className={linkClass('/about')}>
            About
          </a>
        </div>
      </div>
    </nav>
  );
};